//消息接口
import Http from '../Core/Http';
export default class Message extends Http {
  constructor(config) {
    super(config);
  }
  // 首页Banner新闻
  GetHotNews() {
    return this._get('/api/MessageCenter/GetHotNews');
  }
  // 消息中心列表
  GetMessageCenterList(param) {
    return this._get('/api/MessageCenter/GetMessageCenterList', param);
  }
  //根据类型获取
  GetMessageCenterListByType(param) {
    return this._get('/api/MessageCenter/GetMessageCenterListByType', param)
  }
  // 消息详情
  GetMessagedetial(id) {
    return this._get('/api/MessageCenter/GetMessagedetial', {
      messageId: id
    });
  }

  // 消息未读条数
  GetUnReadMessageCount(id) {
    return this._get('/api/MessageCenter/GetUnReadMessageCount', {
      cardId: id
    });
  }

}



// WEBPACK FOOTER //
// ./src/lib/PMA/Message.js